<div class="testimonials">
  <div class="heading">{{config?.title}}<i class="icon-kettobirds"></i></div>
  <div class="donor-note">
    <ngx-glide [showArrows]="false" [showBullets]="false" [perView]="3" [bound]="true" [breakpoints]="breakpoints"
                [gap]="60" arrowLeftLabel="" arrowRightLabel="" [listenToEvents]="true" (ranBefore)="swiped($event)">
      <div *ngFor="let item of config?.testimonials" class="card">
        <div class="widget" [ngClass]="{'active': selectedDonor?.name===item?.name}" (click)="selectDonor(item)">
          <div class="text"><div>{{item?.content}}</div></div>
          <div class="image"><img *ngIf="item?.image" [src]="item?.image" alt="" /><div class="name">{{item?.name}} <span>{{item?.donor_type_text}}</span></div></div>
        </div>
      </div>
    </ngx-glide>
  </div>
</div>